import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { TranslateService } from '@ngx-translate/core';
import RepositoryDirective from 'src/smoothr-web-app-core/directives/repository-directive';
import { ActivatedRoute } from '@angular/router';
import ArticleCategory from 'src/smoothr-web-app-core/models/ArticleCategory';
import { getAvailability, sleep } from 'src/smoothr-web-app-core/utils/utils';
import { OrderType } from 'src/smoothr-web-app-core/enums/OrderType';
import { BehaviorSubject } from 'rxjs';
import { NavigationService, NAVIGATIONURLS } from 'src/services/navigation.service';

@Component({
	selector: 'app-select-category',
	templateUrl: './select-category.page.html',
	styleUrls: ['select-category.page.scss'],
	standalone: false,
})
export class SelectCategoryPage extends RepositoryDirective implements OnInit {
	static url = 'select-category';
	public selectedCategory = '';
	loading = false;

	venueCategories: ArticleCategory[] = [];

	public translate: TranslateService = inject(TranslateService);
	protected repository: RepositoryService = inject(RepositoryService);
	private route: ActivatedRoute = inject(ActivatedRoute);
	private navigationService = inject(NavigationService);

	constructor() {
		super();
	}
	ngOnInit() {
		super.ngOnInit();

		this.route.queryParams.subscribe(value => {
			if (value?.categoryId) {
				this.selectedCategory = value.categoryId;
			}
		});
		console.log(this.venue);
	}

	onVenue() {
		super.onVenue();
		this.venueCategories = (this.venue?.articleCategories ?? [])
			.filter(it => !it.hidden && it.visible)
			.map(cat => {
				if (cat.articles.length > 0) {
					cat.articles = cat.articles.filter(article => {
						return getAvailability(article, OrderType.PREORDER, this.order?.preorder?.type);
					});
				}
				return cat;
			})
			.filter(it => it.articles.length > 0);
	}

	async navToMenu(item: ArticleCategory) {
		if (this.loading) {
			return;
		}
		try {
			this.loading = true;
			await this.navigationService.navigateToUrlWithParams(NAVIGATIONURLS.menu(), { categoryId: item._id });
		} catch (e) {}
		this.loading = false;
	}
	goBack() {
		this.repository.order.emit(null);
		this.navigationService.home();
	}

	toHome() {
		this.navigationService.home();
	}
}
